var parameterInsert={
    IdEnterprise:'',
    IdUser:'',
    IdDocType:'',
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdUserAccessDocument:'', 
    Active:'1',
    User:'',
    IP:'' 
} 
var parameterView={ 
    IdEnterprise:'',
    IdUser:'' 
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}